import React from "react";
import { AgoraVideoPlayer } from "agora-rtc-react";
import { MicFill, MicMuteFill } from "react-bootstrap-icons";
import { classNames } from "../../functions/propsComponent";

export default function VideoPlayer(props) {
  const {
    videoTrack,
    isVideoMute,
    isMicMute,
    title,
    uid,
    isSpeak,
    shareScreen = false,
    isMobile = false,
    tagLable = null,
  } = props;
  console.log(
    "videoPlayer",
    isVideoMute || videoTrack,
    isVideoMute,
    videoTrack
  );
  return (
    <div
      id={"vidComp-" + uid}
      className={classNames(
        isSpeak ? "bg-green-500" : "bg-black",
        " relative  p-1 overflow-hidden border",
        isVideoMute ? "border-secondary-500" : "border-secondary-300"
      )}
      style={{ height: "100%" }}
    >
      {isVideoMute || videoTrack == null ? (
        <div className="aspect-video h-full bg-black w-full"></div>
      ) : (
        <AgoraVideoPlayer
          className={classNames(
            isMobile ? "aspect-[9/16]" : "aspect-video",
            "h-full mx-auto  bg-black"
          )}
          style={{ height: "100%", width: "100%" }}
          // className="vid"
          videoTrack={videoTrack}
        />
      )}

      {shareScreen == false && (
        <>
          {isVideoMute == true ? (
            <div className="absolute top-0 left-0 text-white h-full w-full flex justify-center items-center">
              {isMicMute == true ? (
                <MicMuteFill size={14} className="text-red-500" />
              ) : (
                <MicFill size={14} />
              )}
              <label>{title}</label>
            </div>
          ) : (
            <div className="absolute text-white bottom-0 left-0 px-1 m-1 bg-black line-clamp-1 rounded-sm flex items-center gap-1">
              {isMicMute == true ? (
                <MicMuteFill size={14} className="text-red-500" />
              ) : (
                <MicFill size={14} />
              )}

              <label>{title}</label>
            </div>
          )}
          {tagLable != null && (
            <div className="absolute text-gray-200 -top-0 -left-2 px-1 m-1  line-clamp-1 rounded-sm flex items-center gap-1">
              <label className="px-2 mx-1 py-1  bg-primary-500 rounded-ee-sm text-xs font-bold">
                {tagLable}
              </label>
            </div>
          )}
        </>
      )}
    </div>
  );
}
